import styled from 'styled-components';
import colors from '_colors.module.scss';

export const Subtitle = styled.div`
  padding-left: 1rem;
  border-left: 1px solid ${colors.Border2};
  bds-typo {
    color: ${colors.ContentDisable};
  }
`;
